module.exports = __webpack_public_path__ + "vennBackground.50272c79c6da2d3459d3257b0a867487.svg";